module.exports = __webpack_public_path__ + "static/ss9.c2e31018.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss9.png
// module id = 1205
// module chunks = 81679748166845